import Link from "next/link";
import { workText, projects } from "../../../../../data";
import ProjectGrid from "../../../../components/work/ProjectGrid";
import React from "react";
import HeroWork from "../../Projects/sections/HeroWork";
import posthog from "posthog-js";

const Work = () => {
  return (
    <section
      className="relative z-10 flex w-full flex-col items-center justify-center bg-[#0E1016] bg-cover bg-center py-16 md:py-20 lg:py-20"
      id="work"
    >
      <h2 className="mb-10  text-[36px] text-[#e4ded7] md:mb-16 md:text-[42px] lg:mb-16 lg:text-[72px]">
        {workText.h1}
      </h2>

      <div className="mb-10 flex gap-16 text-[#e4ded7] md:mb-16  lg:mb-20 ">
        <h4
          className={`text-[16px] md:text-[20px] lg:text-[34px] ${"text-[#e4ded7]"}`}
        >
          {workText.h2}
        </h4>
      </div>

      <ProjectGrid projects={projects} />

      <Link
        href="/projects#other"
        className="mt-5"
        onClick={() => {
          posthog.capture("project_showmore", { depth: 1 });
        }}
      >
        <div className="text-[#e4ded7]">{workText.more}</div>
      </Link>
    </section>
  );
};

export default Work;
